import {GetLookupValueName} from "./LookupHelper";

export const GetCryptoAmountRequestedAsSting = (order) => {
    let result = order.cryptoAmountRequested;

    if (order.action === 0) {
        result += ' ' + GetLookupValueName('asset', order.buyAssetId);
    } else if (order.action === 1) {
        result += ' ' + GetLookupValueName('asset', order.sellAssetId);
    }
    return result;
}

export const GetRequestedPricesSting = (order) => {
    if (!order.requestedPrice) {
        return '-';
    }

    let result = order.requestedPrice;

    if (order.action === 0) {
        result += ' ' + GetLookupValueName('asset', order.sellAssetId);
    } else if (order.action === 1) {
        result += ' ' + GetLookupValueName('asset', order.buyAssetId);
    }
    return result;
}

export const GetCryptoAmountExecutedAsSting = (order) => {
    let result = order.cryptoAmountExecuted;

    if (!result) {
        return '-';
    }

    if (order.action === 0) {
        result += ' ' + GetLookupValueName('asset', order.buyAssetId);
    } else if (order.action === 1) {
        result += ' ' + GetLookupValueName('asset', order.sellAssetId);
    }
    return result;
}

export const GetExecutedPricesSting = (order) => {
    let result = order.executedPrice;

    if (!result) {
        return '-';
    }

    if (order.action === 0) {
        result += ' ' + GetLookupValueName('asset', order.sellAssetId);
    } else if (order.action === 1) {
        result += ' ' + GetLookupValueName('asset', order.buyAssetId);
    }
    return result;
}